<script>
    import { Select, Option, Form, FormItem, Input, Checkbox, Popover } from 'element-ui';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';
    import Loader from '~/components/loader/components/loader';
    import Panel from '~/components/panel/components/panel';
    import VueButton from '~/components/button/components/button';
    import FormGroup from '~/components/form/components/form_group';

    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Checkbox);
    Vue.use(Popover);

    export default {
        components: {
            Loader,
            Panel,
            VueButton,
            FormGroup
        },

        data() {
            return {
                newMls: false,
                isOpen: false,
                isIos: false
            }
        },

        computed: {
            ...mapState('newUserRegistrationForm', [
                'formData',
                'lists',
                'loading',
                'stepActive'
            ])
        },

        created() {
            this.checkIosDevice();
            this.updateLoading({ updateAccount: false });
        },

        methods: {
            ...mapActions('newUserRegistrationForm', {
                updateUserAccount: 'updateUserAccount'
            }),

            ...mapMutations('newUserRegistrationForm', {
                updateFormShowingStatus: 'updateFormShowingStatus',
                updateStepStatus: 'updateStepStatus',
                updateLoading: 'updateLoading',
            }),

            handleSubmit() {
                this.updateUserAccount()
                .then(() => {
                    this.updateFormShowingStatus({
                        formName: 'mlsSettingsForm',
                        showingStatus: false
                    });

                    this.updateFormShowingStatus({
                        formName: 'generalInfoForm',
                        showingStatus: true
                    });

                    this.updateStepStatus(1);
                });
            },

            handleMlsCheckChange() {
                this.formData.agent_association = '';
            },

            handleMlsInfoChange() {
                if(this.formData.agent_association.length > 0)
                this.newMls = false;
            },

            handleNewMlsClick(e) {
                e.preventDefault();
                this.isOpen = true;
            },

            checkIosDevice() {
                let userAgent = window.navigator.userAgent;

                this.isIos = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);            }
        }
    }
</script>
<template>
    <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInDown"
    >
        <div>
            <loader :is-loading="loading.updateAccount"></loader>
            <div class="registration-form-top-area">
                <h3>Great! Let's finish setting up your account by adding your agent license and MLS information.</h3>
            </div>
            <panel>
                <div slot="body">
                    <el-form
                        :model="formData"
                        label-position="top"
                        autocomplete="off"
                    >
                        <div class="row">
                            <div class="col-xs-12 col-md-12">
                                <p class="form-text m-b-30">Providing this information allows both you and your co-marketing partners quick and easy access to your listings to create co-branded marketing assets faster.</p>
                            </div>
                            <div class="col-xs-12 col-md-12">
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <el-form-item
                                            label="License Number (optional)"
                                            maxlength="100"
                                        >
                                            <el-input
                                                v-model="formData.license_title"
                                            >
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-12">
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <el-form-item
                                            label="MLS Agent ID (optional)"
                                            maxlength="255"
                                        >
                                            <el-input
                                                v-model="formData.agent_id"
                                                @change="handleMlsInfoChange"
                                            >
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="col-md-6 hidden-xs hidden-sm p-l-0">
                                        <el-popover
                                            ref="popover2"
                                            width="100"
                                            placement="right"
                                            trigger="click"
                                        >
                                            MLS Agent ID is used to automatically<br /> bring in MLS listings when creating<br />marketing content in Total Expert.<br /><br />To provide or update this information, please<br />contact Total Expert Customer Support<br />at <a href="mailto:support@totalexpert.com">support@totalexpert.com</a>.
                                        </el-popover>
                                        <el-form-item
                                            label=" "
                                        >
                                            <span
                                                class="text-info"
                                                v-popover:popover2
                                            >
                                                <i class="fa fa-lg fa-question-circle"></i>
                                            </span>
                                        </el-form-item>

                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <el-form-item
                                    label="MLS Association (optional)"
                                >
                                    <el-select
                                        v-model="formData.agent_association"
                                        clearable
                                        filterable
                                        placeholder="Select association name"
                                        @change="handleMlsInfoChange"
                                    >
                                        <el-option
                                            v-for="item in lists.mlsList"
                                            :key="item.id"
                                            :label="item.mls_name"
                                            :value="item.id"
                                        >
                                        </el-option>
                                     </el-select>
                                </el-form-item>
                                <el-checkbox
                                    v-model="newMls"
                                    @change="handleMlsCheckChange"
                                >
                                    MLS Association Not Listed
                                </el-checkbox>
                            </div>
                            <template v-if="newMls">
                                <div class="col-xs-12 col-md-12">
                                    <el-form-item>
                                        <template v-if="isIos">
                                            <p class="form-text t-m-10">Don't see your MLS Association listed? Click <a href="https://info.totalexpert.com/mls-connect" target="_blank">here</a> to fill out the MLS Connect form or contact Total Expert Customer Support at <a href="tel:800-830-9085">800-830-9085</a></p>
                                        </template>
                                        <template v-else>
                                            <p class="form-text t-m-10">Don't see your MLS board listed? Just fill out the <a href="javascript;" @click="handleNewMlsClick">MLS Connect</a> form and we can get it added for you.</p>
                                        </template>
                                    </el-form-item>
                                </div>
                            </template>
                        </div>
                    </el-form>
                </div>
                <div slot="footer">
                    <div class="row">
                        <div class="col-xs-12 col-md-12 text-right">
                            <vue-button type="primary" @click="handleSubmit">
                                Continue Setting Up Profile
                            </vue-button>
                        </div>
                    </div>
                </div>
            </panel>
            <div class="row">
                <div class="col-xs-12 col-md-12">
                    <div class="registration-form-bottom-area">
                        <h4>Interested in exploring the Total Expert platform? Click <strong><a href="/login">here</a></strong> to sign in.</h4>
                    </div>
                </div>
            </div>
            <el-dialog
                class="el-dialog--grey-bg"
                title="New MLS Connection"
                :modal-append-to-body="false"
                :visible.sync="isOpen"
                :close-on-click-modal="false"
                size="large"
            >
                <div class="embed-responsive embed-responsive-4by3">
                    <iframe style="overflow:scroll;" class="embed-responsive-item" src="https://info.totalexpert.com/mls-connect"></iframe>
                </div>
                <span slot="footer" class="dialog-footer">
                    <vue-button type="primary" @click="isOpen = false">Close</vue-button>
                </span>
            </el-dialog>
        </div>
    </transition>
</template>
<style scoped>
    .registration-form-top-area {
        padding: 60px 0 30px 0;
        text-align: center;
        color: inherit;
    }

    .registration-form-bottom-area {
        padding: 40px 0;
        text-align: center;
        color: inherit;
    }

    .form-text {
        line-height: 1;
        font-size: 16px;
    }
</style>
